import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Popover} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import Icon from '../../core/components/Icon'
import LoaderButton from '../../core/components/LoaderButton'
import {ADD_QUESTION_TO_CAMPAIGN_ACTION_UPDATED, sendAddQuestionToCampaignAction, sendRemoveQuestionFromCampaignAction, loadCampaign} from '../actions'
import {AddQuestionToCampaignAction} from '../models'
import i18n from '../i18n'
import style from './AddRemoveQuestionFromCampaignPopover.less'

class AddRemoveQuestionFromCampaignPopover extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    _sendAddAction() {
        const {dispatch} = this.props
        
        return dispatch(sendAddQuestionToCampaignAction()).then(() => {
            return dispatch(loadCampaign())
        })
    }

    _sendRemoveAction(event, question) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(sendRemoveQuestionFromCampaignAction(question.uid)).then(() => {
            return dispatch(loadCampaign())
        })
    }

    render() {
        const {dispatch, form, action, campaign, onHide, ...others} = this.props

        return (
            <Popover
                title={i18n.question}
                {...others}>
                <ul className={style.questionGroup}>
                    {campaign.questions.slice().reverse().map((question) => (
                        <li key={question.uid}>
                            <a
                                href=''
                                className={style.remove}
                                onClick={(e) => this._sendRemoveAction(e, question)}>
                                <Icon icon='minus' size='xs' />
                            </a>
                            <p>
                                <span>{question.text}</span>
                            </p>
                        </li>
                    ))}
                </ul>
                <form>
                    <Input
                        type='text'
                        name='label'
                        placeholder={i18n.question}
                        {...form.question()} />
                </form>
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendAddAction() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.add}
                    </LoaderButton>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </Popover>
        )
    }
}

AddRemoveQuestionFromCampaignPopover = connectForm({
    target: 'action',
    schema: AddQuestionToCampaignAction.schema,
    action: ADD_QUESTION_TO_CAMPAIGN_ACTION_UPDATED
})(AddRemoveQuestionFromCampaignPopover)

AddRemoveQuestionFromCampaignPopover = connect((state) => ({
    campaign: state.satisfaction.campaign.campaign,
    action: state.satisfaction.addQuestionToCampaignAction
}))(AddRemoveQuestionFromCampaignPopover)

export default AddRemoveQuestionFromCampaignPopover


// WEBPACK FOOTER //
// ./lib/satisfaction/components/AddRemoveQuestionFromCampaignPopover.js